export const LICENSE_WARNING_MESSAGE =
  "A user with this email does not have an Enlighten Pro license in the Spoke Account Portal. Please ensure the user exists in Spoke with an Enlighten Pro license assigned. Otherwise their calls will not be processed, irrespective of the status flag and configuration setup here.";

export const LICENSE_UNAVAILABLE_MESSAGE =
  "Couldn't reach the Spokephone licensing service to verify the user's Enlighten Pro license. Please try again in a moment.";

export const LICENSE_ACTIVE_TOOLTIP = "Enlighten Pro license active";

export const LICENSE_ACTIVE_DESCRIPTION = "Enlighten Pro license active in Spokephone";
